import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';

const TRANSFER_ERROR_MESSAGE =
  'An error occurred while transferring this property. Please try again.';

class TransferProperty extends Component {
  state = {
    defaultManagerOwnerUsername: null,
    errorMessage: null,
    leasingTeamPublicId: null,
    transferringPropertyInProgress: false,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  setLeasingTeamPublicId(event) {
    this.setState({ leasingTeamPublicId: event.target.value });
  }

  setDefaultManagerOwnerUsername(event) {
    this.setState({ defaultManagerOwnerUsername: event.target.value });
  }

  submit(event) {
    event.preventDefault();

    this.setState({
      transferringPropertyInProgress: true,
      errorMessage: null,
    });

    this.props
      .onSubmit(
        this.state.leasingTeamPublicId,
        this.state.defaultManagerOwnerUsername,
      )
      .catch((error) => {
        this.setState({ transferringPropertyInProgress: false });
        if (this.props.shouldShowErrorMessage) {
          const errorMessage = error.message || TRANSFER_ERROR_MESSAGE;
          this.setState({ errorMessage });
        }
      });
  }

  cancel(event) {
    event.preventDefault();
    this.props.onCancel();
  }

  clearErrorMessage = () => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
  };

  render() {
    const { transferringPropertyInProgress } = this.state;

    return (
      <Modal className="user-editor-container">
        <form onSubmit={this.submit} name="transferPropertyForm">
          <ModalHeader>
            <h2>Transfer {this.props.property?.data.location.name}</h2>
          </ModalHeader>
          <ModalContent>
            <div className="knock-react-flex">
              <div>
                <strong>Leasing team public ID to transfer to: </strong>
              </div>
              <div>
                <input
                  aria-label="Leasing team public id"
                  className="knock-react-input"
                  onChange={this.setLeasingTeamPublicId.bind(this)}
                  onFocus={this.clearErrorMessage}
                  type="text"
                  value={this.state.leasingTeamPublicId || ''}
                />
              </div>
            </div>
            <div className="knock-react-flex">
              <div>
                <strong>Default manager owner username: </strong>
              </div>
              <div>
                <input
                  aria-label="Default Manager Owner Username"
                  className="knock-react-input"
                  onChange={this.setDefaultManagerOwnerUsername.bind(this)}
                  onFocus={this.clearErrorMessage}
                  type="text"
                  value={this.state.defaultManagerOwnerUsername || ''}
                />
              </div>
            </div>
            {this.state.errorMessage && (
              <div className="transfer-property-error knock-react-form-hint knock-react-form-hint-error">
                {this.state.errorMessage}
              </div>
            )}
          </ModalContent>
          <ModalFooter>
            <button
              className={`knock-react-button${transferringPropertyInProgress ? ' cancel-hidden' : ''}`}
              onClick={this.cancel.bind(this)}
              type="button"
            >
              Cancel
            </button>
            <button
              className="knock-react-button transfer-submit-button"
              disabled={transferringPropertyInProgress}
            >
              {transferringPropertyInProgress && (
                <i className="fa fa-spinner fa-spin" aria-hidden="true" />
              )}
              {transferringPropertyInProgress ? 'Transferring...' : 'Transfer'}
            </button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

TransferProperty.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  property: PropTypes.shape({
    data: PropTypes.shape({
      location: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
  shouldShowErrorMessage: PropTypes.bool,
};

export default TransferProperty;
